import CONFIG from '../constants/CONFIG';

export const eventCap = new Map();

const queueCallback = (callback, eventAction) => {
  if (eventCap.get(eventAction)?.numberOfCalls >= CONFIG.LOG_GA_EVENT_RETRY_CAP || typeof callback !== 'function') {
    return;
  }

  return setTimeout(() => {
    if (!eventCap?.get(eventAction)) {
      eventCap.set(eventAction, { numberOfCalls: 1 });
    } else {
      eventCap.get(eventAction).numberOfCalls++;
    }

    callback(eventAction);
  }, CONFIG.LOG_GA_EVENT_RETRY_TIMEOUT);
};

export default queueCallback;
